import React from "react";
import { Col } from "react-bootstrap";
import { PlayButton } from "../common/Icons";
import { PrismicRichText } from "@prismicio/react";
import VideoModal from "../blocks/VideoModal";

const Lecture = ({ slice, slices }) => {
  return (
    <Col md={6} className="mb-4">
      {slice.items.map((lecture) => (
        <div className="lecture-container" key={lecture.lecture_title.text}>
          <div className="title-link-container">
            <h6>{lecture.lecture_title.text}</h6>
            &nbsp;
            {lecture.lecture_video?.embed_url && (
              <VideoModal video={lecture.lecture_video} />
            )}
          </div>
          {/* <span>Rich text</span> */}
          <div className="description-container">
            <PrismicRichText field={lecture.lecture_description.richText} />
          </div>
        </div>
      ))}
    </Col>
  );
};

export default Lecture;
